var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Wrapper } from "./styled/DisablePointerEventsOnScroll";
// https://www.thecssninja.com/css/pointer-events-60fps
var DisablePointerEventsOnScroll = /** @class */ (function (_super) {
    __extends(DisablePointerEventsOnScroll, _super);
    function DisablePointerEventsOnScroll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            scrolling: false
        };
        _this.onScrollHandler = function () {
            if (_this.timeout) {
                window.clearTimeout(_this.timeout);
            }
            _this.setState({
                scrolling: true
            });
            _this.timeout = window.setTimeout(_this.onScrollStop, 200);
        };
        _this.onScrollStop = function () {
            _this.timeout = undefined;
            _this.setState({
                scrolling: false
            });
        };
        return _this;
    }
    DisablePointerEventsOnScroll.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.onScrollHandler);
    };
    DisablePointerEventsOnScroll.prototype.componentWillUnmount = function () {
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }
        window.removeEventListener("scroll", this.onScrollHandler);
    };
    DisablePointerEventsOnScroll.prototype.render = function () {
        return React.createElement(Wrapper, { isScrolling: this.state.scrolling }, this.props.children);
    };
    return DisablePointerEventsOnScroll;
}(Component));
export default DisablePointerEventsOnScroll;
